import { ReactElement } from 'react';
import { Field } from 'formik';
import { TextInput, DropdownMenu, TileRadio, AddressField, DateInput, ContactInput } from '@components';
import { tile } from '@interfaces/interfaces';
import gridStyle from '@pages/forms/Grid.module.scss';

function DemoPage(): ReactElement {
  const COUNTRY_DROPDOWN = [
    {
      value: 'Australia',
      display: 'Australia',
    },
    {
      value: 'New Zealand',
      display: 'New Zealand',
    },
  ];

  const OptionOne = (): ReactElement => (
    <>
      <div>Option 1</div>
    </>
  );

  const OptionTwo = (): ReactElement => (
    <>
      <div>Option 2</div>
    </>
  );

  const OptionThree = (): ReactElement => (
    <>
      <div>Option A</div>
    </>
  );

  const OptionFour = (): ReactElement => (
    <>
      <div>Option B</div>
    </>
  );

  const TILE_DATA_A: tile[] = [
    {
      body: <OptionOne />,
      value: 'option1',
    },
    {
      body: <OptionTwo />,
      value: 'option2',
    },
  ];

  const TILE_DATA_B: tile[] = [
    {
      body: <OptionThree />,
      value: 'option3',
    },
    {
      body: <OptionFour />,
      value: 'option4',
    },
  ];

  return (
    <div className={gridStyle.form}>
      {/* By default take up full width */}
      <Field name="Test1" component={TextInput} title="Title" subtitle="Subtitle" isMandatory />
      <div className={gridStyle.gridColFull}>
        <Field name="Test2" component={TextInput} title="Obligation Number" isMandatory />
      </div>

      <Field
        name="validation"
        component={TextInput}
        title="Validation"
        subtitle="This field is required, when you leave it with an invalid input (E.g. leave it empty) it will trigger validation"
        isMandatory
      />

      <ContactInput name="NumberType" secondaryContact />

      <div className={gridStyle.gridColHalf}>
        <Field name="TestA1" component={TextInput} title="Given name(s)" subtitle="Lorem ipsum dolor" isMandatory />
        <Field name="TestA2" component={TextInput} title="Family name" subtitle="Lorem ipsum dolor" />
      </div>

      <div className={gridStyle.gridColQuarter}>
        <Field name="TestC1" component={TextInput} title="One" subtitle="Lorem ipsum dolor" isMandatory />
        <Field name="TestC2" component={TextInput} title="Two" subtitle="Lorem ipsum dolor" isMandatory />
        <Field name="TestC3" component={TextInput} title="Three" subtitle="Lorem ipsum dolor" isMandatory />
        <Field name="TestC4" component={TextInput} title="Four" subtitle="Lorem ipsum dolor" isMandatory />
      </div>

      <Field name="country" component={DropdownMenu} displayText={COUNTRY_DROPDOWN} />
      <Field name="TestD1" title="Option Set" component={TileRadio} tileData={TILE_DATA_A} orientationRow />
      <Field name="TestD2" title="Option Set" component={TileRadio} tileData={TILE_DATA_B} />
      <AddressField name="testAddress" title="Testing address" manualAddressText="Enter your address manually" isMandatory />
      <Field name="testDate" component={DateInput} title="Date of birth" isMandatory placeholder="DD MM YYYY" />
    </div>
  );
}

export default DemoPage;
